import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import api from "services/api"

export function useBecomeMember(memberId: string, config?: UseMutationOptions) {
  return useMutation(
    (data) =>
      api.post(`operation/administration/members/${memberId}/become-member`, {
        data,
      }),
    config
  )
}
